export const PRODUCT_SERVICE_FIELD_TOKEN = "__product_service__";

export const PRODUCT_SERVICE_FIELD_OPTIONS = [
  { code: "sell", name: "Sell" },
  { code: "quantity", name: "Quantity" },
  { code: "msrp", name: "MSRP" },
  { code: "map", name: "MAP" },
  { code: "cost", name: "Cost" },
  { code: "discount", name: "Discount" }
];

export const PRODUCT_SERVICE_FORMULA_MERGE_FIELDS = [
  { value: "[ProductService.Sell]", label: "Product Service: Sell" },
  { value: "[ProductService.Quantity]", label: "Product Service: Quantity" },
  { value: "[ProductService.MSRP]", label: "Product Service: MSRP" },
  { value: "[ProductService.MAP]", label: "Product Service: MAP" },
  { value: "[ProductService.Cost]", label: "Product Service: Cost" },
  { value: "[ProductService.Discount]", label: "Product Service: Discount" }
];

const PRODUCT_SERVICE_TEMPLATE_PREFIX = "template_ps:";
const PRODUCT_SERVICE_ADD_ITEM_PREFIX = "add_item_action:";

export const isProductServiceFieldToken = (value) => value === PRODUCT_SERVICE_FIELD_TOKEN;

export const encodeTemplateProductServiceRef = (documentItemProductServiceId) =>
  `${PRODUCT_SERVICE_TEMPLATE_PREFIX}${documentItemProductServiceId}`;

export const encodeAddItemActionProductServiceRef = (actionId) =>
  `${PRODUCT_SERVICE_ADD_ITEM_PREFIX}${actionId}`;

export const parseProductServiceReference = (value) => {
  const ref = String(value || "");
  if (ref.startsWith(PRODUCT_SERVICE_TEMPLATE_PREFIX)) {
    return {
      type: "template",
      id: ref.slice(PRODUCT_SERVICE_TEMPLATE_PREFIX.length)
    };
  }
  if (ref.startsWith(PRODUCT_SERVICE_ADD_ITEM_PREFIX)) {
    return {
      type: "add_item_action",
      id: ref.slice(PRODUCT_SERVICE_ADD_ITEM_PREFIX.length)
    };
  }
  return { type: "", id: "" };
};

